<ng-container
  *ngIf="banner$ | async as banner"
  [cxComponentWrapper]="{
    flexType: banner.typeCode,
    typeCode: banner.typeCode,
    uid: banner?.uid,
  }"
  (cxComponentRef)="setRef($event)"
></ng-container>
